import { render, staticRenderFns } from "./CustomersCountWidget.vue?vue&type=template&id=e0f0355a&"
import script from "./CustomersCountWidget.vue?vue&type=script&lang=js&"
export * from "./CustomersCountWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports